import { authRequest } from './api/auth';

class UsageAnalysisService {
    totalcost() {
        return authRequest.get(`/upgpt/v2/usage/aitotalusage/`);
    }
    chart(mode,bot,model,knowledge,start,end,user) {
        // return authRequest.get(`/chatgpt/upgpt/aiusagerecord/?mode=${mode}&bot=${bot}&model=${model}&start=${start}&end=${end}`);
        return authRequest.get('/upgpt/v2/usage/aiusagerecord/', { params: { mode: String(mode), bot: String(bot), model: String(model), knowledge: String(knowledge), start: String(start), end: String(end), user: String(user) } });
    }
    list(mode,bot,model,knowledge,start,end,page,page_item,user) {
        // return authRequest.get(`/chatgpt/upgpt/aiusagerecord/?mode=${mode}&bot=${bot}&model=${model}&start=${start}&end=${end}&page=${page}&page_item=${page_item}`);
        return authRequest.get('/upgpt/v2/usage/aiusagerecord/', { params: { mode: String(mode), bot: String(bot), model: String(model), knowledge: String(knowledge), start: String(start), end: String(end), page: String(page), page_item: String(page_item), user: String(user) } });
    }
    chatlist(mode,bot,start,end,page,page_item,search) {
        // return authRequest.get(`/chatgpt/upgpt/chathistory/?mode=${mode}&bot=${bot}&start=${start}&end=${end}&page=${page}&page_item=${page_item}&search=${search}`);
        return authRequest.get('/upgpt/v2/usage/chathistory/', { params: { mode: String(mode), bot: String(bot), start: String(start), end: String(end), page: String(page), page_item: String(page_item), search: search == null ? '' : String(search) } });
    }
    chatsingle(id,conv_id,search) {
        // return authRequest.get(`/chatgpt/upgpt/chathistory_single/?id=${id}&search=${search}`);
        return authRequest.get('/upgpt/v2/usage/chathistory_single/', { params: { id, conversation_id: conv_id == null ? '' : conv_id, search: search == null ? '' : search } });
    }
    knowledge_select_list(){
        return authRequest.get(`/upgpt/v2/usage/aiusageknowledgelist/`);
    }
}
export default new UsageAnalysisService();